<!-- 商品管理 V2 - 批量审核操作确认弹框 -->
<template>
  <el-dialog :title="title" :visible.sync="visible" width="560px" append-to-body custom-class="batch-audit-dialog">
    <div class="audit-dialog-content">
      <p class="audit-warning">{{ warning }}</p>
      <div class="audit-groups">
        <div v-for="group in groups" :key="group.user_id" class="audit-customer-group">
          <p>{{ $t('message.clientID') }}：{{ group.user_id }}</p>
          <p v-for="code in group.client_sku_codes" :key="code">{{ code }}</p>
        </div>
      </div>
    </div>
    <span slot="footer">
      <el-button @click="visible = false">{{ $t('message.cancel') }}</el-button>
      <template v-if="mode === 'audit'">
        <el-button class="reject-button" @click="submit('reject')">打回</el-button>
        <el-button type="primary" @click="submit('approve')">审核通过</el-button>
      </template>
      <el-button v-else type="primary" @click="submit('no_need')">{{ $t('message.submit') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'BatchAuditDialog',
  data() {
    return { visible: false, loading: false, mode: 'no_need', list: [] }
  },
  computed: {
    groups() {
      const groups = {}
      this.list.forEach(item => {
        if (!groups[item.user_id]) groups[item.user_id] = { user_id: item.user_id, client_sku_codes: [] }
        groups[item.user_id].client_sku_codes.push(item.client_sku_code)
      })
      return Object.values(groups)
    },
    title() {
      return this.mode === 'audit' ? '批量审核提示' : '提交无须维护提示'
    },
    warning() {
      return this.mode === 'audit' ? '当前审核以下选中的管理番号' : '以下选中的管理番号是否批量提交无须维护'
    }
  },
  methods: {
    open(list, mode) {
      this.list = list.slice()
      this.mode = mode || 'no_need'
      this.visible = true
    },
    async submit(action) {
      this.loading = true
      try {
        const api = this.mode === 'audit' ? 'batchAudit' : 'submitNoNeed'
        const data = { sys_code_set: this.list.map(item => item.sys_code) }
        if (this.mode === 'audit') data.action = action
        const res = await this.$api.productManagementApi[api](data)
        this.$message.success(res.msg)
        this.visible = false
        this.$emit('success')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss">
.batch-audit-dialog {
  .el-dialog__body { padding: 24px 28px 8px; }
  .audit-dialog-content { padding: 0 4px; }
  .audit-warning { margin: 0 0 12px; color: #333; line-height: 20px; }
  .audit-groups { display: flex; flex-wrap: wrap; gap: 20px; }
  .audit-customer-group { min-width: 110px; }
  .audit-customer-group p { margin: 0; line-height: 20px; word-break: break-all; }
  .reject-button { border-color: #c77a12; background: #c77a12; color: #fff; }
}
</style>
